module.exports = __webpack_public_path__ + "img/Slide3.9dea2038.jpg";